module.exports = __webpack_public_path__ + "media/soundtrack.125e4584.mp3";